import { useEffect } from "react"

import { ENV } from "@/config/env"

/**
 * Dev-only hook to toggle dark mode with keyboard shortcut
 *
 * Shortcut: Option + Shift + W (⌥⇧W)
 *
 * Toggles the 'dark' class on the <html> element to test dark mode instantly.
 * Only active in development mode.
 */
export function useDevDarkModeToggle() {
  useEffect(() => {
    // Only enable in development
    if (ENV.NODE_ENV !== "development") {
      return
    }

    function handleKeyDown(e: KeyboardEvent) {
      // Option + Shift + W (check both e.key and e.code to handle any keyboard layout)
      const isWKey = e.key === "w" || e.key === "W" || e.code === "KeyW"

      if (e.altKey && e.shiftKey && isWKey) {
        e.preventDefault()

        const html = document.documentElement
        const isDark = html.classList.contains("dark")

        if (isDark) {
          html.classList.remove("dark")
          console.log("🌞 Dark mode OFF")
        } else {
          html.classList.add("dark")
          console.log("🌙 Dark mode ON")
        }
      }
    }

    document.addEventListener("keydown", handleKeyDown)

    // Log shortcut on mount (dev only)
    console.log("🌓 Toggle dark mode shortcut: ⌥⇧W (Dev only)")

    return () => {
      document.removeEventListener("keydown", handleKeyDown)
    }
  }, [])
}
